<div class="alarm_box_headers" [ngStyle]="{border:'1px solid #e8e8e8 !important'}">
  <div class="flex_10 text-center">#</div>
  <div class="flex_50 text-center">Alarm Type</div>
  <div class="flex_30 text-center">Timestamp</div>
  <div class="flex_10 text-center">Status</div>
</div>
<div class="alerts_container" [ngStyle]="{'background-color':'white !important'}">
  <div class="alarm_box_column" *ngFor="let alert of alerts">
    <div class="flex_10 text-center">{{ alert.sensor_marker }}</div>
    <div class="flex_50 alert_name">
      {{ alert.error }}
    </div>
    <div class="flex_30 alert_time" (click)="openFftTime(alert)">{{ alert.time }}</div>
    <div class="flex_10 center_flex">
      <button class="btn btn-warning" (click)="OnClickAlert(alert)" >OPEN</button>
    </div>
  </div>
  <div class="text-center mt-4" style="margin:7rem" *ngIf="this.isEmpty">No alerts in last 24 hrs</div>
</div>
